import { type MultipleQueriesQuery } from '@algolia/client-search';
import { type SearchRequest as ElasticSearchRequest } from '@elastic/elasticsearch/lib/api/types';
import { merge } from 'merge-anything';

import { type BettingInsightsSortConfig } from '~/configuration/betting-insights/elasticsearch/BettingInsightsElasticSearch';
import { type BettingSplitsIndex } from '~/configuration/betting-insights/types';
import { convertSortingConfigToSortingValue } from '~/utils/convertSortingConfigToSortingValue';

type SearchRequest = {
	body: ElasticSearchRequest;
	indexName: string;
	request: MultipleQueriesQuery;
};

export const bettingSplitsQueryFactory =
	({
		sorting,
	}: {
		sorting?: BettingInsightsSortConfig<BettingSplitsIndex>[];
	}) =>
	(searchRequest: SearchRequest): SearchRequest => {
		const indexName = searchRequest.indexName;

		const activeSort = sorting?.find(sort => {
			return (
				`${indexName}${convertSortingConfigToSortingValue(sort)}` ===
				searchRequest.request.indexName
			);
		}) ?? {
			field: 'subeventStartTime',
			order: 'asc',
		};

		const order = {
			[activeSort.field]: activeSort.order,
		};

		const sortAggregate = {
			[activeSort.field]: {
				max: {
					field: activeSort.field,
				},
			},
		};

		const query = merge(searchRequest, {
			body: {
				size: 0,
				aggs: {
					subevents: {
						terms: {
							field: 'subeventId',
							size: 10000,
							order,
						},
						aggs: {
							...sortAggregate,
							markets: {
								terms: {
									field: 'marketId',
									size: 10000,
								},
								aggs: {
									bets: {
										terms: {
											field: 'betId',
											size: 10000,
										},
										aggs: {
											best_odds: {
												top_hits: {
													sort: {
														oddsDecimal: 'desc',
													},
													size: 1,
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
		});

		return query;
	};
